import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import "bootstrap-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import Layout from "../../../../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useGetCentresQuery,
  useGetCityQuery,
  useGetRrbQuery,
  useGetStatesQuery,
} from "../../../../store/Api/common";
import {
  validationSchemaCenFi,
  validationSchemaCenSe,
} from "../../../../Utils/ValidationSchema";
import { hidetoast, useDecodeToken } from "../../../../Utils/function";
import {
  useAddStateMutation,
  useEditStateMutation,
} from "../../../../store/Api/masterDataApi/state";
import CreateStateUi from "./CreateStateUi";

// Define validation schema using Yup

function CreateState() {
  const dispatch = useDispatch();
  // const { id } = useParams();
  const navigate = useNavigate();
  const decodedToken = useDecodeToken();
  const location = useLocation(); // Access state
  const { state } = location;
  const id = state?.data?.id
  const [addState] = useAddStateMutation();
  const [updateState] = useEditStateMutation();
  const [isCenError, setIsCenError] = useState("");
  const [rrbId, setRrbId] = useState(
    decodedToken?.role == 1
      ? `${decodedToken?.rrb_id}`
      : id
      ? state?.data?.rrb_id
      : ""
  );

  const [selectData, setSelectData] = useState({
    rrb: [],
  });
  const { data: rrb, isFetching, isLoading } = useGetRrbQuery({});
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);
  const validationSchema =
  ( decodedToken?.role == 3 || decodedToken?.role == 4)
      ? Yup.object({
          rrb_id: Yup.string().required("Please select an RRB"),
        })
      : "validationSchemaStateFi";
  useEffect(() => {
    setSelectData({
      rrb: rrb?.data?.data,
    });
  }, [rrb]);

  const handleSubmit = async (values) => {
    let isError = false;
    if (values.states) {
      values.states.forEach((name) => {
        if (!name.trim()) {
          isError = true;
        }
      });
    } else {
      isError = true;
    }
    if (isError) {
      setIsCenError("State Name is required");
    } else {
      const data = id
        ? {
            rrb_id: parseInt(values?.rrb_id),
            name: values?.states[0],
          }
        : {
            rrb_id: parseInt(values?.rrb_id),
            states: values?.states,
          };
      try {
        const response = id
          ? await updateState({ id, data })
          : await addState(data);
        if (response?.data?.success) {
          navigate("/master-data/state");
        }
      } catch (error) {
        console.log(error, "verify otp error");
      }
    }
  };
  const addNewCenField = (formik) => {
    const currentCens = formik.values.states || [];
    formik.setFieldValue("states", [...currentCens, ""]);
  };

  const handleCenChange = (formik, index, value) => {
    const currentCens = [...formik.values.states];
    currentCens[index] = value;
    formik.setFieldValue("states", currentCens);
    setIsCenError("");
  };

  const removeCenField = (formik, index) => {
    const currentCens = [...formik.values.states];
    currentCens.splice(index, 1);
    formik.setFieldValue("states", currentCens);
  };
  return (
    <Layout>
      <Formik
        initialValues={
          ( decodedToken?.role == 3 || decodedToken?.role == 4)
            ? {
                rrb_id: id ? state?.data?.rrb_id : "",
                states: id ? [state?.data?.name] : [""],
              }
            : {
                rrb_id: decodedToken?.rrb_id,
                states: id ? [state?.data?.name] : [""],
              }
        }
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <CreateStateUi
            formik={formik}
            id={id}
            addNewCenField={() => addNewCenField(formik)}
            handleCenChange={(index, value) =>
              handleCenChange(formik, index, value)
            }
            removeCenField={(index) => removeCenField(formik, index)}
            selectData={selectData}
            setRrbId={setRrbId}
            setSelectData={setSelectData}
            decodedToken={decodedToken}
            isCenError={isCenError}
            toast={toast}
          />
        )}
      </Formik>
    </Layout>
  );
}

export default CreateState;
